import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "./ui/button";
import { Menu } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";
import { trackCallClick } from "../lib/tracking";

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-md border-b border-border">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="relative w-32 h-10 lg:w-44 lg:h-14 flex-shrink-0 transition-transform duration-300 group-hover:scale-105">
              <img src="/Certif/Logo.png" alt="Mac-Support Pro Solution" className="w-full h-full object-contain" />
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            <a href="/#services" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors relative group">
              Services
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary group-hover:w-full transition-all duration-300"></span>
            </a>
            <a href="/#pricing" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors relative group">
              Tarifs
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary group-hover:w-full transition-all duration-300"></span>
            </a>
            <a href="/#faq" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors relative group">
              FAQ
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary group-hover:w-full transition-all duration-300"></span>
            </a>
          </nav>

          <div className="flex items-center gap-3">
            <div className="hidden md:flex items-center gap-3">
              <a href="tel:+33189707560" onClick={() => trackCallClick("header")} className="inline-flex items-center justify-center rounded-md text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2 shadow-md hover:shadow-lg hover:scale-105 transition-all duration-300">
                +33 1 89 70 75 60
              </a>
              <Link to="/login">
                <Button variant="outline" className="hover:scale-105 transition-transform duration-300 text-sm">
                  Mon compte client
                </Button>
              </Link>
            </div>

            <Sheet open={open} onOpenChange={setOpen}>
              <SheetTrigger asChild className="md:hidden">
                <Button variant="ghost" size="icon" className="hover:bg-accent">
                  <Menu className="h-5 w-5" />
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-[320px] sm:w-[400px] p-0">
                <div className="flex flex-col h-full">
                  <div className="px-6 pt-8 pb-6 border-b border-border">
                    <div className="relative w-40 h-12 mb-4">
                      <img src="/Certif/Logo.png" alt="Mac-Support Pro Solution" className="w-full h-full object-contain" />
                    </div>
                  </div>
                  <nav className="flex-1 px-6 py-6">
                    <div className="flex flex-col gap-1">
                      <a href="/#services" onClick={() => setOpen(false)} className="text-base font-semibold text-foreground hover:text-primary hover:bg-accent rounded-lg px-4 py-3 transition-colors duration-200">Services</a>
                      <a href="/#pricing" onClick={() => setOpen(false)} className="text-base font-semibold text-foreground hover:text-primary hover:bg-accent rounded-lg px-4 py-3 transition-colors duration-200">Tarifs</a>
                      <a href="/#faq" onClick={() => setOpen(false)} className="text-base font-semibold text-foreground hover:text-primary hover:bg-accent rounded-lg px-4 py-3 transition-colors duration-200">FAQ</a>
                    </div>
                  </nav>
                  <div className="px-6 pb-6 pt-4 border-t border-border space-y-3">
                    <a href="tel:+33189707560" onClick={() => { trackCallClick("header_mobile"); setOpen(false); }} className="inline-flex items-center justify-center rounded-md text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90 w-full h-11 shadow-md">+33 1 89 70 75 60</a>
                    <Link to="/login" className="w-full block" onClick={() => setOpen(false)}>
                      <Button variant="outline" className="w-full h-11">Mon compte client</Button>
                    </Link>
                  </div>
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </header>
  );
}
